import CssBaseline from "@mui/material/CssBaseline";
import type { Theme } from "@mui/material/styles";
import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import type { ReactNode } from "react";

export function ThemeProvider({
  theme,
  children,
}: {
  theme: Partial<Theme> | ((outerTheme: Theme) => Theme);
  children: ReactNode;
}) {
  return (
    <MUIThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        {children}
      </LocalizationProvider>
    </MUIThemeProvider>
  );
}
